module.exports = __webpack_public_path__ + "img/maiao.2107a4e6.png";